import {
  Card,
  CardBody,
  CardFooter,
  Stack,
  Text,
  Divider,
  Flex,
  Box,
  Heading,
  IconButton,
  Grid,
  GridItem,
  Button,
  Image,
  Modal,
} from "@chakra-ui/react"

import { FC, memo, useCallback, useEffect, useState } from "react"
import { TypeSelectedData } from "../../types/TypeSelectedData"
import { ImageWithSpinAnimation } from "./ImageWithSpinAnimation"
import "../../../css/MobileDetailDialog.scss"

import { BsPinAngleFill } from "react-icons/bs"
import { LikeButton } from "../useLikeButton"
import { HeightCalculation, WidthCalculation } from "../../SizeCaluculation"
import { HeartBubbleParticles } from "../MyParticles"

type Props = TypeSelectedData & {
  TypeMenu: string
  length?: number
  LikeCount: number
  setLikeCount: React.Dispatch<React.SetStateAction<number>>
  modalFlag?: boolean
  ModalLayout: number
}

const getCardTitle = (Title: string, TopicBody: string) => {
  // 日付形式のパターン（yyyy/MM/dd hh::mm:ssの...）をチェック
  const datePattern = /^\d{4}\/\d{2}\/\d{2}\s\d{2}:\d{2}:\d{2}の.*/

  if (Title && !datePattern.test(Title)) {
    return Title
  } else {
    return TopicBody
  }
}

export const ButtonCard: FC<Props> = memo((props) => {
  const {
    Title,
    Medias,
    TopicBody,
    TypeMenu,
    TopicID,
    length,
    LikeCount,
    setLikeCount,
    modalFlag,
    WallLikes,
    ModalLayout,
  } = props
  const CardImage: string[] = []
  let CardWidth = WidthCalculation(430, 320)
  let FixedCardHeight = HeightCalculation(530, 310)

  // getCardTitle関数を使用してタイトルを決定
  const displayTitle = getCardTitle(Title, TopicBody)

  // 詳細画面でのカードの大きさ
  if (modalFlag) {
    //固定カードのサイズ
    if (length) {
      FixedCardHeight = HeightCalculation(245, 335)
      if (length === 1) {
        CardWidth = WidthCalculation(345, 540)
      } else if (length === 2) {
        CardWidth = WidthCalculation(254, 432)
      } else {
        CardWidth = WidthCalculation(254, 324)
      }
    } else {
      // 移動カードのサイズ
      CardWidth = WidthCalculation(412, 412)
      FixedCardHeight = HeightCalculation(244, 334)
    }

    // 基本画面のカードの大きさ
  } else {
    //固定カードのサイズ
    if (length) {
      if (length === 1) {
        FixedCardHeight = HeightCalculation(520, 310)
      } else if (length === 2) {
        FixedCardHeight = HeightCalculation(330, 310)
      } else {
        FixedCardHeight = HeightCalculation(325, 310)
      }
    }
    // 移動カードのサイズ
    CardWidth = WidthCalculation(430, 320)
  }

  let ImageHeight = FixedCardHeight - HeightCalculation(160, 160)

  if (modalFlag) {
    ImageHeight = FixedCardHeight * 0.8
  } else {
    if (length == 3) {
      ImageHeight = FixedCardHeight * 0.8
    } else {
      ImageHeight = FixedCardHeight - HeightCalculation(160, 160)
    }
  }

  const FooterRepeat = Math.floor(CardWidth / WidthCalculation(50, 20))
  Medias.map((media) => {
    if (media.TYPE === "image" || media.TYPE === "thumbnail") {
      CardImage.push(media.URL)
    }
  })
  return (
    <Box
      mt={!modalFlag && length ? `${HeightCalculation(0, 20)}px` : "0px"}
      width={`${CardWidth}px`}
      height={length ? `${FixedCardHeight}px` : "auto"}
      boxShadow="xl"
      borderRadius="3xl"
      borderBottom="2px solid #CCCCCC"
      position="relative"
    >
      {LikeCount > 9 && !modalFlag && (
        <HeartBubbleParticles id={TopicID.toString()} LikeCount={LikeCount} />
      )}
      <Card
        width={`${CardWidth}px`}
        height={length ? `${FixedCardHeight}px` : "auto"}
        boxShadow="xl"
        borderRadius="3xl"
        backgroundColor={length || modalFlag ? "white" : "tranceparent"}
      >
        <CardBody padding="0px">
          {(modalFlag || length) && CardImage[0] != undefined ? (
            <div style={{ position: "relative" }}>
              <Image
                style={{
                  width: `${CardWidth}px`,
                  height: `${ImageHeight}px`,
                  objectFit: "cover",
                  borderRadius: "25px 25px 0px 0px",
                }}
                alt={`${displayTitle} `}
                src={CardImage[0]}
              />
              {length && (
                <div style={{ position: "absolute", top: 10, right: 10 }}>
                  <BsPinAngleFill
                    size={WidthCalculation(30, 30)}
                    color="white"
                  />
                </div>
              )}
            </div>
          ) : null}
          {(modalFlag || length) && CardImage[0] == undefined ? (
            <div
              style={{
                width: `${CardWidth}px`,
                height: `${ImageHeight}px`,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: "transparent",
                borderRadius: "25px 25px 0px 0px",
                fontSize: "20px",
                color: "#333",
                textAlign: "center",
                paddingLeft: "15px",
                paddingRight: "15px",
                borderBottom: "2px solid #B0B0B0",
              }}
            >
              <Text
                style={{ userSelect: "none" }}
                whiteSpace="pre-wrap"
                overflowWrap="break-word"
                fontSize={`${WidthCalculation(18, 18)}px`}
                textOverflow="ellipsis"
                noOfLines={3}
              >
                {Title}
              </Text>
            </div>
          ) : null}

          {!modalFlag && length == undefined && CardImage[0] != undefined && (
            <ImageWithSpinAnimation
              CardWidth={CardWidth}
              Img={CardImage}
              Title={displayTitle}
            />
          )}
          {!modalFlag && (
            <Stack
              mt={`${Math.round(HeightCalculation(4, 4))}`}
              spacing={`${Math.round(HeightCalculation(3, 3))}`}
              pl={`${Math.round(WidthCalculation(5, 5))}`}
              pr={`${Math.round(WidthCalculation(5, 5))}`}
            >
              <Text
                style={{ userSelect: "none" }}
                whiteSpace="pre-wrap"
                overflowWrap="break-word"
                fontSize={`${WidthCalculation(18, 18)}px`}
                textOverflow="ellipsis"
                noOfLines={length && length == 3 ? 2 : 3}
              >
                {displayTitle}
              </Text>
            </Stack>
          )}
        </CardBody>

        <CardFooter padding="0px" paddingTop="5px">
          <Grid
            h={`${HeightCalculation(50, 50)}px`}
            w={`${CardWidth * 0.977}px`}
            templateColumns={`repeat(${FooterRepeat}, 1fr)`}
            gap={0}
            pl={3}
          >
            <GridItem
              justifySelf="start"
              colSpan={1}
              className={`${TypeMenu} icon`}
            />
            <GridItem
              colSpan={FooterRepeat - 4}
              pl={3}
              pt={modalFlag ? 2 : "0px"}
            >
              {length && (
                <Text
                  style={{ userSelect: "none" }}
                  fontSize={
                    modalFlag
                      ? `${WidthCalculation(16, 16)}px`
                      : `${WidthCalculation(24, 24)}px`
                  }
                  alignItems="center"
                  whiteSpace="pre-wrap"
                  overflowWrap="break-word"
                  textOverflow="ellipsis"
                  noOfLines={1}
                  color="gray.700"
                >
                  {displayTitle}
                </Text>
              )}
            </GridItem>
            <GridItem justifySelf="end" colSpan={3} className="cardLikeButton">
              <LikeButton
                TopicID={TopicID}
                WallLike={LikeCount}
                setLikeCount={setLikeCount}
                buttonColor={"#C53030"}
                ModalLayout={ModalLayout}
              />
            </GridItem>
          </Grid>
        </CardFooter>
      </Card>
    </Box>
  )
})
